import { render, staticRenderFns } from "./modalEstadisticas.vue?vue&type=template&id=5461f8ce&scoped=true&"
import script from "./modalEstadisticas.vue?vue&type=script&lang=js&"
export * from "./modalEstadisticas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5461f8ce",
  null
  
)

export default component.exports